export default  (obj) => {
  return obj ? +obj.hours + obj.minutes / 60 : 0;
};